
export default {
    name: 'Index',
    data() {
        return {
            info:{},
            isShow:false, 
            isShowForeCast:false,
            foreCastInfo:[],
            foreCastInfo1:{},
            foreCastInfo2:{},
            chartDatachanpin: {},
            chartDatadiqu: {},
            chartDatayingshou:{},
            chartDatamaoli:{},
            chartDatalirun: {},
            chartDatajinglirun:{},
            chartDatayingxiaofeiyong:{},
            stockcode:'',
            loading:null,
            ifloading:false,
            zhuyinggouchengData:null,
            isShowzygc:false,
            favoriteState:'加入收藏'


        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
            if(this.$route.query.code!=null &&this.$route.query.code!=undefined){
                this.update(); 
                this.searchChartsData();
                this.GetFavoriteState();


            }
        },
     
       
        // 用于更新一些数据
        async update() {
            this.ifloading=true
            this.stockcode=this.$route.query.code
            const res = await this.$http.post('DownEast/SearchCompanyInfoByCode', {code:this.stockcode });
            if(res.Status)
            {
                this.downUsFinanceCastByCode()
                var that=this
                this.info=res.Result;
                let zhuyingchanp=[]; 
                res.Result.zhuyinggoucheng_chanpin.forEach(function (v) { 
                   
                    zhuyingchanp.push({value: Math.round(v.ratio * 100) / 100,name:v.productname,detail: that.Bigmoney(v.mbrevenue*1)});
                })
                this.chartDatachanpin={data:zhuyingchanp,title:'主营构成-产品'};

                
                let zhuyingdiq=[]; 
                res.Result.zhuyinggoucheng_diqu.forEach(function (v) {  
                    zhuyingdiq.push({value:Math.round(v.ratio* 100) / 100,name:v.regionname,detail: that.Bigmoney(v.mbrevenue*1)});
                })

                this.chartDatadiqu={data:zhuyingdiq,title:'主营构成-地区'};
            }
            this.ifloading=false
        },
 


        async showZygc(){
            
            this.$router.push('/Company/?code='+this.stockcode.toUpperCase()) 

        },
        async searchChartsData(){
            if(this.stockcode!=''){
        
                const res = await this.$http.post('DownEast/SearchFinanceInfoOfUsByCode', {code:this.stockcode });
                if(res.Status){  
                    this.loadChartsData(res) 
                    this.loadChartsYingShouData() 
                }
                else if(res.Msg=="待下载")
                {  
                   // this.downChartsData(); 
                }  

            }
           


        },
        async downUsFinanceCastByCode(){
            const res = await this.$http.post('DownYh/SearchUsFinanceCastByCode', {code:this.stockcode });
        
               
        },
        async downChartsData(){
            if(this.stockcode!='' &&this.stockcode!=undefined){
                this.showLoading('数据下载中') 
                const res = await this.$http.post('DownEast/DownUsPublishFinanceInfoByCode', {code:this.stockcode });
                if(res.Status){
                
                    this.$success('下载成功！'); 
                    this.searchChartsData();
                    this.close();
                }
                else
                { 
                    this.close();
                }

            }
           

        },
        async loadChartsYingShouData(){
            const res = await this.$http.post('DownEast/SearchFinanceInfoOfUsYingShouByCode', {code:this.stockcode });
            if(res.Status){  


                 //营收 开始
            var yingshou=[];
            var tongbi=[];
            var huanbi=[];
            var xtitles=[];
            var yingshoucolor=[];
            var bizhong=""
            res.Result.forEach(function (item) { 
                yingshoucolor.push("#B22222") 

                yingshou.push(item.yingyeshouru) 
                if(bizhong==""){
                    bizhong=item.bizhong
                }
            
                if(item.yingyeshourutongbi!=null && item.yingyeshourutongbi!=undefined)
                {
                    
                    tongbi.push(item.yingyeshourutongbi)

                }
                else
                {
                    
                    tongbi.push(0)

                }

                if(item.yingyeshouruhuanbi!=null && item.yingyeshouruhuanbi!=undefined){

                    huanbi.push(item.yingyeshouruhuanbi)
                  
                }else{
                    huanbi.push(0)
                }

                xtitles.push(item.caibaoleixing)

            });
 
            this.chartDatayingshou=
            {
                colorlist:yingshoucolor,
                zhuzhuangdata:yingshou,
                zhuzhuangdatatitle:yingshou,
                zhexiandata1:tongbi,
                zhexiandatatitle1:tongbi,
                zhexiandata2:huanbi,
                zhexiandatatitle2:huanbi,
                xtitle:xtitles,
                xzhou:["营收","同比","环比"],
                text:{name:"营业收入",subname:"单位:百万"+bizhong}
            };
             //营收结束 

            
            }
        },
        async loadChartsData(res){
             
            this.showLoading('数据加载')
            if(res.Status){ 


                   //营收 开始
            var yingshou=[];
            var tongbi=[];
            var huanbi=[];
            var xtitles=[];
            var yingshoucolor=[];     
            var bizhong;
            res.Result.forEach(function (item) { 
               
                xtitles.push(item.caibaoleixing)
                bizhong=item.bizhong

            });
 
         
             //营收结束 

            //毛利开始
            var maoli=[];
            var maolititle=[];
            var maolilv=[];
            var maolilvtitle=[];
            var maolicolor=[];
            res.Result.forEach(function (item) {  
                if(parseFloat(item.maoli)<0){
                    maolicolor.push("#00CD66") 
                 }
                 else
                 {
                    maolicolor.push("#B22222") 
                 }

                maoli.push(Math.abs(parseFloat(item.maoli))) 
                maolititle.push(item.maoli)  
                
                maolilv.push(Math.abs(parseFloat(item.maolilv)))   
                maolilvtitle.push(item.maolilv) 

            });
             
            
            this.chartDatamaoli=
            {
                colorlist:maolicolor,
                zhuzhuangdata:maoli,
                zhuzhuangdatatitle:maolititle,
                zhexiandata1:maolilv,
                zhexiandatatitle1:maolilvtitle,
                xtitle:xtitles,
                xzhou:["毛利","毛利率"],
                text:{name:"毛利",subname:"单位:百万"+bizhong}
            };
            //毛利 结束


            //利润开始
            var lirun=[];
            var liruntitle=[];
            var lirunlv=[];
            var lirunlvtitle=[];
            var liruntongbi=[];
            var liruntongbititle=[];
            var liruncolor=[];
            res.Result.forEach(function (item) {  


                if(parseFloat(item.yingyelirun)<0)
                {
                    liruncolor.push("#00CD66") 
                 }
                 else
                 {
                    liruncolor.push("#B22222") 
                 }
 
                lirun.push(Math.abs(parseFloat(item.yingyelirun))) 
                liruntitle.push(item.yingyelirun) 
                
                lirunlv.push(Math.abs(parseFloat(item.yingyelirunlv))) 
                lirunlvtitle.push(item.yingyelirunlv) 
            });
            
         

            
            this.chartDatalirun=
            {
                colorlist:liruncolor,
                zhuzhuangdata:lirun,
                zhuzhuangdatatitle:liruntitle,
                zhexiandata1:lirunlv,
                zhexiandatatitle1:lirunlvtitle,
                xtitle:xtitles,
                xzhou:["利润","利润率"],
                text:{name:"利润",subname:"单位:百万"+bizhong}
            };
            //利润 结束
            
            console.warn('chartDatalirun:',this.chartDatalirun)
 

                
            //净利润开始
            var jinglirun=[];
            var jingliruntitle=[];
            var jingliruntongbi=[];
            var jingliruntongbititle=[];
            
            var jinglirunhuanbi=[];
            var jinglirunhuanbititle=[];
            var  jingliruncolor=[];
            res.Result.forEach(function (item) {  
               
                if(parseFloat(item.jinglirun)<0){
                    jingliruncolor.push("#00CD66") 
                 }
                 else{
                    jingliruncolor.push("#B22222") 
                 }

                jinglirun.push(Math.abs(parseFloat(item.jinglirun))) 
                jingliruntitle.push(item.jinglirun) 
                if(item.jingliruntongbi!=null && item.jingliruntongbi!=undefined)
                { 
                    
                jingliruntongbi.push(Math.abs(parseFloat(item.jingliruntongbi))) 
                jingliruntongbititle.push(item.jingliruntongbi) 

                }else{
                    jingliruntongbi.push(0) 
                    jingliruntongbititle.push(0) 

                }

                if(item.jinglirunhuanbi!=null && item.jinglirunhuanbi!=undefined){
                    
                jinglirunhuanbi.push(Math.abs(parseFloat(item.jinglirunhuanbi))) 
                jinglirunhuanbititle.push(item.jinglirunhuanbi) 

                }
                else{
                    
                jinglirunhuanbi.push(0) 
                jinglirunhuanbititle.push(0) 
                }
            });
             
            this.chartDatajinglirun=
            {
                colorlist:jingliruncolor,
                zhuzhuangdata:jinglirun,
                zhuzhuangdatatitle:jingliruntitle,
                zhexiandata1:jingliruntongbi,
                zhexiandatatitle1:jingliruntongbititle,
                zhexiandata2:jinglirunhuanbi,
                zhexiandatatitle2:jinglirunhuanbititle,
                xtitle:xtitles,
                xzhou:["净利润","同比","环比"],
                text:{name:"净利润",subname:"单位:百万"+bizhong}
            };
            //净利润 结束 


             //营销费用开始
             var yingxiaofeiyong=[];
             var yingxiaofeiyongtitle=[];
             var yingxiaofeiyongtongbi=[];
             var yingxiaofeiyongtongbititle=[];
             
             var yingxiaofeiyonghuanbi=[];
             var yingxiaofeiyonghuanbititle=[];
             var  yingxiaofeiyongcolor=[];
             res.Result.forEach(function (item) {  
                
                  if(parseFloat(item.yingxiaofeiyong)<0)
                  {
                    yingxiaofeiyongcolor.push("#00CD66") 
                  }
                  else
                  {
                    yingxiaofeiyongcolor.push("#B22222") 
                  }
 
                  yingxiaofeiyong.push(Math.abs(parseFloat(item.yingxiaofeiyong))) 
                  yingxiaofeiyongtitle.push(item.yingxiaofeiyong) 
                 
                  if(item.yingxiaofeiyongtongbi!=null &&item.yingxiaofeiyongtongbi!=undefined){
                      
                  yingxiaofeiyongtongbi.push(Math.abs(parseFloat(item.yingxiaofeiyongtongbi))) 
                  yingxiaofeiyongtongbititle.push(item.yingxiaofeiyongtongbi) 

                  }
                  else
                  {
                      
                  yingxiaofeiyongtongbi.push(0) 
                  yingxiaofeiyongtongbititle.push(0) 
                  }


                  if(item.yingxiaofeiyonghuanbi!=null &&item.yingxiaofeiyonghuanbi!=undefined){
                      
                  yingxiaofeiyonghuanbi.push(Math.abs(parseFloat(item.yingxiaofeiyonghuanbi))) 
                  yingxiaofeiyonghuanbititle.push(item.yingxiaofeiyonghuanbi) 

                  }else{
                      
                  yingxiaofeiyonghuanbi.push(0) 
                  yingxiaofeiyonghuanbititle.push(0) 
                  }

             });
              
             this.chartDatayingxiaofeiyong={
                 colorlist:yingxiaofeiyongcolor,
                 zhuzhuangdata:yingxiaofeiyong,
                 zhuzhuangdatatitle:yingxiaofeiyongtitle,
                 zhexiandata1:yingxiaofeiyongtongbi,
                 zhexiandatatitle1:yingxiaofeiyongtongbititle,
                 zhexiandata2:yingxiaofeiyonghuanbi,
                 zhexiandatatitle2:yingxiaofeiyonghuanbititle,
                 xtitle:xtitles,
                 xzhou:["营销费用","同比","环比"],
                 text:{name:"营销费用",subname:"单位:百万"+bizhong}
                };
             //营销费用 结束 

            }

            this.close() 

        },  
        close() { 
            if(this.loading)
            this.loading.close();
        },
        showLoading(txt) {
            this.close();
            this.loading = this.$loading({
                lock: true,
                text: txt+'……',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
       showDetail(){
            this.isShow=true
        },
        async GetFavoriteState(){
            const res = await this.$http.post('StockFavorite/FoundStockFavorite', {code:this.stockcode });
           if(res.Status){
                this.favoriteState="已收藏";
           }
        },  
        async addFavorite(){
            const res = await this.$http.post('StockFavorite/AddOrUpdateStockFavorite', {
                code:this.stockcode,stockType:'us' });
            if(res.Status){
                this.favoriteState="已收藏";
                this.$success('收藏成功！'); 
           }

        },

        async showReportDetail(){
            this.isShow=true
    
        },
       async showForecast(){
        this.isShowForeCast=true
        this.foreCastInfo={_id:"数据载入中",content:'数据正在载入请稍后'}
        this.showLoading('数据加载中') 
        const res1 = await this.$http.post('DownYh/GetUsFinanceCastContentByCode', {code:this.stockcode});
        if(res1.Status){
           this.foreCastInfo=res1.Result;
           this.close();
        }
        // else
        // {
        //     this.downForecastContent()

        // }
 

        // const res2 = await this.$http.post('DownYh/GetUsFinanceInfoByCode', {code:this.stockcode,reportType:2});
        // if(res2.Status){
        //    this.foreCastInfo2=res2.Result;
        // } 
        
        
        },
        async downForecastContent(){
       
        this.showLoading('数据加载中') 
            const res = await this.$http.post('DownYh/DownUsFinanceCastContent', {code:this.stockcode});
            if(res.Status){
                this.showForecast();
                this.close();
             }else{
                this.close();

             }
    
        },
        Bigmoney(value){
            var param = {};
            var k = 10000,
                sizes = ['', '万', '亿', '万亿'],
                i;
            if (value < k) {
                param.value = value
                param.unit = ''
            } else {
                i = Math.floor(Math.log(value) / Math.log(k));
        
                param.value = ((value / Math.pow(k, i))).toFixed(2);
                param.unit = sizes[i];
            }
            return param.value+param.unit;
        }

    },
    // 计算属性
    computed: {
        identity() {
            let identity = '园长';
            return identity;
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
       // this.update(); 
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => {
            console.warn('code:',this.$route.query.code)
            this.init();
           // this.searchChartsData()
         });
    },
    beforeCreate () {
       
      },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { 
        
    },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        
        //监听相同路由下参数变化的时候，从而实现异步刷新
        $route(to,from) {
            this.init();
         //   this.searchChartsData()
        },
    },
    // 组件列表
    components: {},
};